import {
  GET_MEMO,
  GET_MEMO_SUCCESS,
  API_ERROR

} from "./actionTypes"

export const GetMemo = guid => ({
  type: GET_MEMO,
  payload: guid,
})

export const GetMemoSuccess = record => ({
  type: GET_MEMO_SUCCESS,
  payload: record,
})

export const MemoError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

